import type { PageLoad } from './$types';

export const load = (async () => {
	return {
		title: 'Start Investing with Confidence to Grow Your Wealth',
		description:
			"Because growing your wealth isn't just about saving more — it's about making every dollar work smarter."
	};
}) satisfies PageLoad;
